import Typography, { TypographyProps } from '@mui/material/Typography';
import { useSkinStyles } from '../../hooks/useSkinStyles';
import { BETSLIP_INFO_MESSAGE_SKIN_STYLES } from '../../styles/components/betslipInfoMessage';

import { mergeSx } from '../../utils/styles';

type BetslipInfoMessageProps = {
  message: string;
};

const BetslipInfoMessage = ({ message, ...rest }: BetslipInfoMessageProps & TypographyProps) => {
  const styles = useSkinStyles(BETSLIP_INFO_MESSAGE_SKIN_STYLES);

  return (
    <Typography
      variant='body3'
      {...rest}
      sx={mergeSx(
        {
          textAlign: 'center',
        },
        styles.message,
        rest.sx
      )}
    >
      {message}
    </Typography>
  );
};

export default BetslipInfoMessage;
